import React from "react"

export default ({ item, fallbackAlt, index }) => {
  const isVideo = !item.fixed
  const alt = item?.description || fallbackAlt
  const lazy = index > 0

  if (isVideo) {
    return (
      <div className="gallery-media">
        <video
          playsInline
          controls
          preload={lazy ? "none" : "metadata"}
          aria-label={alt || "Project video"}
          className="gallery-video"
        >
          <track kind="captions" srcLang="en" />
          <source src={item.file.url} type="video/mp4" />
        </video>
      </div>
    )
  }

  const isPortrait = item.fixed.height > item.fixed.width
  const src = isPortrait ? item.fixed.src : item.fixedCropped?.src || item.fixed.src
  const frameStyle = isPortrait
    ? { aspectRatio: `${item.fixed.width} / ${item.fixed.height}` }
    : { aspectRatio: "3 / 2" }

  return (
    <div className={`gallery-media${isPortrait ? " gallery-media--portrait" : ""}`}>
      <div className="gallery-media__frame" style={frameStyle}>
        <img
          src={src}
          alt={alt}
          className="gallery-media__img"
          loading={lazy ? "lazy" : "eager"}
          decoding={lazy ? "async" : "auto"}
        />
      </div>
    </div>
  )
}
